export default __webpack_public_path__ + "static/media/ero_dark_east.bf516381.svg";